import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { ProfileView } from '@/features/profile/components/profile-view'

const profileSearchSchema = z.object({
  tab: z.enum(['profil', 'tozsamosc', 'ustawienia']).optional(),
  sub: z.enum(['numerologia', 'zodiak', 'chinski']).optional(),
})

export const Route = createFileRoute('/_authed/profile')({
  validateSearch: (search) => profileSearchSchema.parse(search),
  component: ProfileView,
})
